import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType, FieldTypeConfig, FormlyModule } from "@ngx-formly/core";
import { TranslateModule } from "@ngx-translate/core";
import { CoreSelectorComponent } from "src/app/core/core-selector/core-selector.component";

export type SelectorOption = Record<string, unknown>;

/**
 * Custom Formly field type for core selector (checkbox/radio groups).
 * Wraps the CoreSelectorComponent for use in Formly forms.
 */
@Component({
  selector: "app-formly-core-selector",
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    FormlyModule,
    CoreSelectorComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <fieldset class="form-group">
      @if (props.label) {
      <legend class="col-form-label">{{ props.label | translate }}</legend>
      }
      <app-core-selector
        [type]="props['selectorType'] || 'checkbox'"
        [filterOptions]="selectorOptions"
        [selectorValue]="props['selectorValue'] || 'id'"
        [selectorLabel]="props['selectorLabel'] || 'name'"
        [limit]="props['limit'] || 10"
        [formControl]="formControl"
      ></app-core-selector>
    </fieldset>
  `,
})
export class CoreSelectorFieldComponent extends FieldType<FieldTypeConfig> {
  override defaultOptions = {
    props: {
      selectorType: "checkbox",
      options: [] as SelectorOption[],
      selectorValue: "id",
      selectorLabel: "name",
      limit: 10,
    },
  };

  get selectorOptions(): SelectorOption[] {
    return Array.isArray(this.props.options) ? this.props.options : [];
  }
}
